export default __webpack_public_path__ + "static/media/508.c1012302.jpg";